import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ExitToApp from '@material-ui/icons/ExitToApp'

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import PeopleIcon from '@material-ui/icons/People';
import StoreIcon from '@material-ui/icons/Store';
import EditIcon from '@material-ui/icons/Edit';
import AssignmentIcon from '@material-ui/icons/Assignment';
import SearchIcon from '@material-ui/icons/Search';
import FaceIcon from '@material-ui/icons/Face';
import PersonPinIcon from '@material-ui/icons/PersonPinCircle';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Input from '@material-ui/core/Input';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import Select from '@material-ui/core/Select';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';
import LinearProgress from '@material-ui/core/LinearProgress';
import CircularProgress from '@material-ui/core/CircularProgress';
import Switch from '@material-ui/core/Switch';
import Snackbar from '@material-ui/core/Snackbar';
import _ from "lodash";
import firebase from '../../Firebase';
import AsyncStorage from '@callstack/async-storage';
import FileUploader from 'react-firebase-file-uploader';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';
import Mainmenu from '../../components/mainmenu';
import MoreVertIcon from '@material-ui/icons/MoreVert';

const drawerWidth = 240;

const DialogTitle = withStyles(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing.unit * 2,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing.unit,
    top: theme.spacing.unit,
    color: theme.palette.grey[500],
  },
}))(props => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="Close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing.unit * 2,
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    borderTop: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing.unit,
  },
}))(MuiDialogActions);

const styles = theme => ({
  '@global': {
    '*::-webkit-scrollbar': {
      width: '0.4em'
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: '#f2a811',
      borderRadius: '5px',
    }
  },
  hide: {
    display:'none',
  },
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
    backgroundColor: '#f2a811',
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    //justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  toolbarAvatar: {
    borderRadius: 0,
    width: 170,
    left: 10,
  },
  toolbarIconButton:{
    right:0,
    position:'absolute'
  },
  avatar:{
    backgroundColor: '#b1730d',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9,
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    height: '100vh',
    overflow: 'auto',
  },
  chartContainer: {
    marginLeft: -22,
  },
  tableContainer: {
    height: 320,
  },
  h5: {
    marginBottom: theme.spacing.unit * 2,
  },
  loadingColorPrimary: {
    backgroundColor: '#f2a811',
  },
  loadingBarColorPrimary: {
    backgroundColor: '#b1730d',
  },
  input: {
    '&:after': {
      borderBottomColor: '#f2a811',
    },
  },
  table: {
    width: '100%',
    overflowX: 'auto',
  },
  button: {
    marginBottom: 15,
    color: '#fff',
    backgroundColor: '#f2a811',
    '&:hover': {
      backgroundColor: '#b1730d',
    },
  },
  form: {
    width: '100%',
    //marginTop: theme.spacing.unit,
  },
  label: {
    '&$cssFocused': {
      color: '#f2a811',
    },
  },
  input: {
    '&:after': {
      borderBottomColor: '#f2a811',
    },
  },
  buttonProgress: {
    color: "#fff",
  },
  avatarProgress: {
    color: '#f2a811',
    zIndex: 999,
  },
  avatarProgressTxt: {
    color: '#f2a811',
  },
  snackbar_icon: {
    fontSize: 20,
  },
  checkbox: {
    color: '#f2a811',
    '&$checked': {
      color: '#f2a811',
    },
  },
  iOSSwitchBase: {
    '&$iOSChecked': {
      color: theme.palette.common.white,
      '& + $iOSBar': {
        backgroundColor: '#f2a811',
      },
    },
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp,
    }),
  },
  iOSChecked: {
    transform: 'translateX(15px)',
    '& + $iOSBar': {
      opacity: 1,
      border: 'none',
    },
  },
  iOSBar: {
    borderRadius: 13,
    width: 42,
    height: 26,
    marginTop: -13,
    marginLeft: -21,
    border: 'solid 1px',
    borderColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  iOSIcon: {
    width: 24,
    height: 24,
  },
  iOSIconChecked: {
    boxShadow: theme.shadows[1],
  },
  color_b1730d:{
    color:"#b1730d"
  },
  div_100p:{
    width: "100%",
    marginTop: 15,
    marginBottom: 15,
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

class Users extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      drawer: true,
      loading: true,
      searchedTxt: "",
      searchedArr: [],
      user:{},
      users: [],
      switches: [],
      config:{},

      imageUploading: false,
      imageUploadProgress: -1,

      adding: false,
      dialog: false,
      dialogType: "add",
      menus: [],
      image:"",
      firstName: "",
      middleName: "",
      lastName: "",
      email: "",
      mobile: "",
      addresses: [],
      roles: [],
      unfilteredUsers: [],
      form_errors:[],
      password: '',
      editID: ''
    }
  }

  componentWillMount(){
    AsyncStorage.getItem("user").then(u => {
      if (u) {
        const t = this;
        let switches = [];
        let user = JSON.parse(u);

        /*if(!user.roles.includes("admin") && user.roles.includes("seller"))
          this.props.navigation.navigate("Inventory");*/

        firebase.firestore().collection("config").get().then(snapshot => {
          this.setState({config:JSON.parse(snapshot.docs[0]._document.data.toString())});
        });

        firebase.firestore().collection('users').onSnapshot(function(docs) {
          let users = [];
          docs.forEach(doc => {
            let user = JSON.parse(doc._document.data.toString());
            user.id = doc.id;
            users.push(user);
            switches.push(user.active);
          });
          t.setState({ unfilteredUsers: users, user:user, users:users, switches:switches, loading:false});
        });
      } else
        this.props.navigation.navigate('Login');
    });
  }

  async logout(){
    try {
      //await AsyncStorage.removeItem('user');
      this.props.navigation.navigate('Login');
    } catch (error) {
      console.log(error);
    }
  }

  toggleDrawer(){
    this.setState({ drawer:!this.state.drawer });
  }

  toggleDialog(){
    this.setState({ dialog:!this.state.dialog, imageUploading:false, imageUploadProgress:-1, image:"", firstName:"", middleName:"", lastName:"", email:"", mobile:"", addresses:[], roles:[], dialogType:"", adding:false, });
  }

  toggleAdd(obj){
    this.toggleDialog();
    this.setState({dialogType:"add"});
  }

  toggleSwitch(i, obj){
    const t = this;
    let switches = t.state.switches;
    switches[i] = !switches[i];

    firebase.firestore().collection("users").get().then(function(querySnapshot) {
      querySnapshot.forEach(function(doc) {
        firebase.firestore().collection('users').doc(obj.id).update({
          active: switches[i],
        }).then( ()=> {
          t.setState({switches:switches});
        }).catch( error => {
          console.log(error);
        });
      });
    });
  }

  stringify(arr){
    let str = "";
    if(arr.length == 1)
      str = arr[0];
    else{
      arr.map((a, i) => {
        if(i == (arr.length-1))
          str += a;
        else
          str += a+", ";
      });
    }
    return str;
  }

  onSearch(s){

    console.log(this.state.unfilteredUsers)
    if(s!=''){
      let usr = []
       usr = _.filter(this.state.unfilteredUsers, function(o) { 
        return o.firstName.toLowerCase().includes(s.toLowerCase()) 
        || (o.lastName+"").toLowerCase().includes(s.toLowerCase())
        || (o.middleName+"").toLowerCase().includes(s.toLowerCase())
        || (o.mobile+"").toLowerCase().includes(s.toLowerCase())
        || (o.roles).includes(s.toLowerCase())
      });

      this.setState({users: usr})
    }else{
         this.setState({users: this.state.unfilteredUsers})
    }

    /*let searchedArr = [];
    let searched = s.toUpperCase();
    let users = this.state.users;
    users.map((u, i) => {
      const name = u.firstName.toUpperCase()+" "+u.middleName.toUpperCase()+" "+u.lastName.toUpperCase(),
            email = u.email.toUpperCase(),
            mobile = u.mobile.toUpperCase(),
            roles = this.stringify(u.roles).toUpperCase();
      if(name.includes(searched) || email.includes(searched) || mobile.includes(searched) || roles.includes(searched))
        searchedArr.push(u);
    });
    this.setState({ searchedArr:searchedArr, searchedTxt:s});*/
  }

  goTo(p){
    this.props.navigation.navigate(p);
  }

  checkUserTableRows(usr){
    let totalUndefined = 0;

    usr.map(u => {
      if(u == undefined)
        totalUndefined++;
    });

    if(usr.length == totalUndefined)
      return true
    else
      return false
  }

  onRoleSelect(e){
    this.setState({ roles: e.target.value });
  }

  toggleMenu(event, i, bool){
    var menus = this.state.menus;
    menus[i] = bool;
    this.setState({menus:menus, anchorEl:(bool ? event.currentTarget : null )});
  }

  toggleEdit(obj){
    console.log('obj',obj);
    this.toggleDialog();
    this.setState({ editID: obj.id, image:obj.selfie, roles: obj.roles, dialogType:"edit", firstName: obj.firstName, middleName: obj.middleName, lastName: obj.lastName});
  }

  edit(){
    let that = this

    firebase.firestore().collection('users').doc(that.state.editID).update({
        firstName: that.state.firstName,
        middleName: that.state.middleName,
        lastName: that.state.lastName,
        roles: that.state.roles,
        updated_at: firebase.firestore.FieldValue.serverTimestamp(),
      }).then(() => {
        that.toggleDialog();
      }).catch( error => {
        console.log(error);
        that.toggleDialog();
      });

  }
  add(){
    let errors = [];

    if(this.state.adding)
      errors.push("currently adding");
    if(this.state.image == "")
      errors.push("image is required");
    if(this.state.firstName == "")
      errors.push("first name is required");
    if(this.state.middleName == "")
      errors.push("middle name is required");
    if(this.state.lastName == "")
      errors.push("last name is required");
    if(this.state.password == "")
      errors.push("password required");
    if(this.state.mobile == "")
      errors.push("mobile number is required");
    if(_.isEmpty(this.state.roles))
      errors.push("at least one role is required");

    this.setState({form_errors:errors});

    if(_.isEmpty(errors))
    {
      this.setState({adding:true});

      firebase
        .auth()
        .createUserWithEmailAndPassword(this.state.mobile+"@easysuki.com", this.state.password)
        .then((res) => { 

          let that = this

          firebase.firestore().collection('users').doc(res.user.uid).set({
              firstName: this.state.firstName,
              middleName: this.state.middleName,
              lastName: this.state.lastName,
              mobile: this.state.mobile,
              addresses: this.state.addresses,
              roles: this.state.roles,
              selfie: this.state.image,
              allow_multiple_orders: false,
              active: true,
              created_at: firebase.firestore.FieldValue.serverTimestamp(),
            }).then(() => {
              this.toggleDialog();
            }).catch( error => {
              console.log(error);
              this.toggleDialog();
            });
          
        })
        .catch(error => { 
          console.log('error',error.message)
          this.setState({ errorMessage: error.message }) 
        })
    }
  }

  render() {
    const { classes } = this.props;
    let users = this.state.users;
    let form_errors = this.state.form_errors;
    let roles = ["admin","buyer","seller","rider"];
    let summary = {};
    let userTableRows;
    let addingErrorSnackbar;
    let rolesMenu;

    if(!_.isEmpty(users)){
      if(this.state.searchedTxt != "")
        users = this.state.searchedArr;

      summary.users = users.length;
      summary.sellers = 0;
      summary.buyers = 0;
      summary.riders = 0;

      userTableRows = users.map((u, i) => {
        if(u.roles.includes("seller"))
          summary.sellers++;
        if(u.roles.includes("buyer"))
          summary.buyers++;
        if(u.roles.includes("rider"))
          summary.riders++;

        return (
          <TableRow key={i}>
            <TableCell component="th" scope="row">
              { u.selfie == "" ?
                  <Avatar className={classes.avatar}>
                    <FaceIcon/>
                  </Avatar>
                :
                  <Avatar alt={u.firstName+' '+u.middleName+' '+u.lastName} src={u.selfie} />
              }
            </TableCell>
            <TableCell component="th" scope="row">{u.firstName+' '+u.middleName+' '+u.lastName}</TableCell>
            <TableCell component="th" scope="row">{u.mobile}</TableCell>
            <TableCell component="th" scope="row">{this.stringify(u.roles)}</TableCell>
            <TableCell component="th" scope="row">
              <Switch
                disableRipple
                checked={this.state.switches[i]}
                onChange={() => this.toggleSwitch(i, u)}
                value="checkedA"
                classes={{
                  switchBase: classes.iOSSwitchBase,
                  bar: classes.iOSBar,
                  icon: classes.iOSIcon,
                  iconChecked: classes.iOSIconChecked,
                  checked: classes.iOSChecked,
                }}
              />
            </TableCell>
            <TableCell component="th" scope="row">
                <IconButton
                    aria-label="More"
                    aria-owns={this.state.menus[i] ? 'render-props-menu-'+i : undefined}
                    aria-haspopup="true"
                    onClick={(e) => this.toggleMenu(e, i, true)}
                  >
                <MoreVertIcon />
                </IconButton>
                <Menu id={"render-props-menu-"+i} open={this.state.menus[i]} anchorEl={this.state.anchorEl} onClose={(e) => this.toggleMenu(e, i, false)}>
                    <MenuItem onClick={() => { this.toggleEdit(u) }}>
                      <ListItemIcon><EditIcon /></ListItemIcon>
                      <Typography variant="inherit" noWrap>Edit</Typography>
                    </MenuItem>
                </Menu>
            </TableCell>
          </TableRow>
        );
      });
    }

    if(!_.isEmpty(form_errors)){
      let form_errors_list;
      form_errors_list = form_errors.map(e => {
        return ( <li>{e}</li> );
      });
      addingErrorSnackbar = [
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          open={true}
          autoHideDuration={6000}
          onClose={() => this.setState({form_errors:[]})}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={
            <div id="message-id">
              <p><ErrorIcon className={classes.snackbar_icon} />{ " Add failed" }</p>
              <ul>{ form_errors_list }</ul>
            </div>
          }
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              className={classes.close}
              onClick={() => this.setState({form_errors:[]})}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
      ];
    }

    if(!_.isEmpty(roles)){
      rolesMenu = roles.map((r, i) => {
        return(
          <MenuItem key={i} value={r}>
            <Checkbox color="#f2a811" className={classes.checkbox} checked={this.state.roles.indexOf(r) > -1} />
            <ListItemText primary={r} />
          </MenuItem>
        );
      });
    }

    return (
      <div className={classes.root}>
        <CssBaseline />
        <AppBar
          position="absolute"
          className={classNames(classes.appBar, this.state.drawer && classes.appBarShift)}
        >
          <Toolbar disableGutters={!this.state.drawer} className={classes.toolbar}>
            <IconButton
              color="inherit"
              aria-label="Open drawer"
              onClick={() => this.toggleDrawer()}
              className={classNames(
                classes.menuButton,
                this.state.drawer && classes.menuButtonHidden,
              )}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              className={classes.title}
            >
              Users
            </Typography>
            <IconButton color="inherit" onClick={() => this.logout()}>
              <ExitToApp />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Drawer
          variant="permanent"
          classes={{
            paper: classNames(classes.drawerPaper, !this.state.drawer && classes.drawerPaperClose),
          }}
          open={this.state.drawer}
        >
          <div className={classes.toolbarIcon}>
            <Avatar src="https://firebasestorage.googleapis.com/v0/b/easysuki-dev.appspot.com/o/assets%2FeasySuki-toolbar.png?alt=media&token=3b713ebc-804c-4e5f-8362-aa5d48f5ff29" className={classes.toolbarAvatar}/>
            <IconButton onClick={() => this.toggleDrawer()} className={classes.toolbarIconButton}>
              <ChevronLeftIcon />
            </IconButton>
          </div>
          <Divider />
          <Mainmenu navigation={this.props.navigation} active="users" />
        </Drawer>
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          {/*<Typography variant="h4" gutterBottom component="h2">
            Orders
          </Typography>
          <Typography component="div" className={classes.chartContainer}>
            <SimpleLineChart />
          </Typography>
          <Typography variant="h4" gutterBottom component="h2">
            Products
          </Typography>
          <div className={classes.tableContainer}>
            <SimpleTable />
          </div>*/}
          <div className={classes.tableContainer}>
            { !this.state.loading &&
              [
                <Grid container spacing={24}>
                  <Grid key={0} item xs={12} sm={12} md={10} lg={10}>
                    <FormControl fullWidth className={classes.margin}>
                      <Input
                        placeholder="Search"
                        className={classes.input}
                        onChange={event => this.onSearch(event.target.value)}
                        startAdornment={<InputAdornment position="start"><SearchIcon/></InputAdornment>}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={12} md={2} lg={2}>
                    
                    <Button
                      fullWidth
                      variant="contained"
                      className={classes.button}
                      onClick={() => { if(!this.state.adding){ this.toggleAdd() } }}
                    >
                      Add User
                    </Button>
                  </Grid>
                </Grid>,
                <br key={1} />,
                
                  <Grid key={2} container spacing={24}>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                      <Paper>
                        <center>
                          {"Users"}
                          <Typography className={classes.color_b1730d} component="h2" variant="display1" gutterBottom>
                            { _.isEmpty(users) ? 0 : summary.users }
                          </Typography>
                        </center>
                      </Paper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                      <Paper>
                        <center>
                          {"Buyers"}
                          <Typography className={classes.color_b1730d} component="h2" variant="display1" gutterBottom>
                            { _.isEmpty(users) ? 0 : summary.buyers }
                          </Typography>
                        </center>
                      </Paper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                      <Paper>
                        <center>
                          {"Sellers"}
                          <Typography className={classes.color_b1730d} component="h2" variant="display1" gutterBottom>
                            { _.isEmpty(users) ? 0 : summary.sellers }
                          </Typography>
                        </center>
                      </Paper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                      <Paper>
                        <center>
                          {"Riders"}
                          <Typography className={classes.color_b1730d} component="h2" variant="display1" gutterBottom>
                            { _.isEmpty(users) ? 0 : summary.riders }
                          </Typography>
                        </center>
                      </Paper>
                    </Grid>
                  </Grid>,
                <br key={3} />,
              ]
            }
            { this.state.loading ?
                <Paper className={classes.root}>
                  <Table className={classes.table}>
                    <LinearProgress
                      classes={{
                        colorPrimary: classes.loadingColorPrimary,
                        barColorPrimary: classes.loadingBarColorPrimary,
                      }}
                    />
                  </Table>
                </Paper>
              :
                <Paper className={classes.root}>
                    <Table className={classes.table}>
                      <TableHead key={1}>
                        <TableRow>
                          <TableCell>Avatar</TableCell>
                          <TableCell>Name</TableCell>
                          <TableCell>Mobile</TableCell>
                          <TableCell>Roles</TableCell>
                          <TableCell>Deactivate</TableCell>
                        </TableRow>
                      </TableHead>,
                      <TableBody key={2}>
                        {userTableRows}
                      </TableBody>
                    </Table>
                </Paper>
            }
          </div>
        </main>
        <Dialog
          onClose={() => {this.setState({dialog:false})}}
          aria-labelledby="customized-dialog-title"
          open={this.state.dialog}
        >
          <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
            { this.state.dialogType == "add" && "Add User" }
            { this.state.dialogType == "edit" && "Edit User" }
            { this.state.dialogType == "delete" && "Confirm Delete" }
          </DialogTitle>
          <DialogContent>
            { this.state.dialogType == "add" || this.state.dialogType =="edit" &&
              <form className={classes.form}>
                <center>
                  <label>
                    { this.state.imageUploadProgress == -1 ?
                        <Avatar src={ this.state.image == "" ? "images/camera.png" : this.state.image} style={{pointer:'cursor', width:80, height:80, backgroundColor:"#f2a811"}}/>
                      :
                        <CircularProgress size={80} className={classes.avatarProgress} />
                    }
                    <FileUploader
                      hidden
                      accept="image/*"
                      name="avatar"
                      randomizeFilename
                      storageRef={firebase.storage().ref('/selfies')}
                      onUploadStart={() => this.setState({imageUploading:true})}
                      onUploadError={(error) => console.log(error)}
                      onUploadSuccess={(filename) => {
                        firebase.storage().ref("/selfies").child(filename).getDownloadURL().then((url) => {
                          this.setState({ image:url, imageUploadProgress:-1 });
                        });
                      }}
                      onProgress={(progress) => this.setState({imageUploadProgress:progress})}
                    />
                  </label>
                  { this.state.imageUploadProgress != -1 && [<br key={0}/>, <label key={1} className={classes.avatarProgressTxt}>{ 'Uploading... '+this.state.imageUploadProgress+' %' }</label>] }
                </center>
                <FormControl margin="normal" required fullWidth>
                  <InputLabel className={classes.label}>First Name</InputLabel>
                  <Input id="firstName" name="firstName" autoComplete="firstName" value={this.state.firstName} className={classes.input}
                    onChange={event => {
                      const { value } = event.target;
                      this.setState({ firstName: value });
                    }}
                  />
                </FormControl>
                <FormControl margin="normal" required fullWidth>
                  <InputLabel className={classes.label}>Middle Name</InputLabel>
                  <Input id="middleName" name="middleName" autoComplete="middleName" value={this.state.middleName} className={classes.input}
                    onChange={event => {
                      const { value } = event.target;
                      this.setState({ middleName: value });
                    }}
                  />
                </FormControl>
                <FormControl margin="normal" required fullWidth>
                  <InputLabel className={classes.label}>Last Name</InputLabel>
                  <Input id="lastName" name="lastName" autoComplete="lastName" value={this.state.lastName} className={classes.input}
                    onChange={event => {
                      const { value } = event.target;
                      this.setState({ lastName: value });
                    }}
                  />
                </FormControl>

                { this.state.dialogType == "add" &&
                   <FormControl margin="normal" required fullWidth>
                      
                      <TextField label="Password" type="password" id="password" name="password" autoComplete="password" value={this.state.password} className={classes.input}
                        onChange={event => {
                          const { value } = event.target;
                          this.setState({ password: value });
                        }}
                      />
                    </FormControl>
                }
                
                { this.state.dialogType == "add" &&
                  <FormControl margin="normal" required fullWidth>
                    <InputLabel className={classes.label}>Mobile</InputLabel>
                    <Input id="mobile" name="mobile" autoComplete="mobile" value={this.state.mobile} className={classes.input}
                      onChange={event => {
                        const { value } = event.target;
                        this.setState({ mobile: value });
                      }}
                    />
                  </FormControl>
                }
                <FormControl margin="normal" required fullWidth>
                  <InputLabel className={classes.label}>{"Role/s"}</InputLabel>
                  <Select
                    multiple
                    value={this.state.roles}
                    className={classes.input}
                    onChange={(e) => this.onRoleSelect(e)}
                    input={<Input id="select-multiple-chip" />}
                    renderValue={selected => (
                      <div className={classes.chips}>
                        {selected.map((value, i) => (
                          <Chip key={i} label={value} className={classes.chip} />
                        ))}
                      </div>
                    )}
                    MenuProps={MenuProps}
                  >
                    { rolesMenu }
                  </Select>
                </FormControl>
              </form>
            }
          </DialogContent>
          <DialogActions>
            { this.state.dialogType == "add" &&
                <Button className={classes.button} onClick={() => this.add()} color="primary">
                  { this.state.adding ?
                      <CircularProgress size={24} className={classes.buttonProgress} />
                    :
                      "Add"
                  }
                </Button>
            }

            { this.state.dialogType == "edit" &&
                <Button className={classes.button} onClick={() => this.edit()} color="primary">
                  { this.state.adding ?
                      <CircularProgress size={24} className={classes.buttonProgress} />
                    :
                      "Save"
                  }
                </Button>
            }
            <Button className={classes.button} onClick={() => {this.setState({dialog:false})}} color="primary">
              { "Close" }
            </Button>
          </DialogActions>
        </Dialog>
        { addingErrorSnackbar }
      </div>
    );
  }
}

Users.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Users);